import { Location } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatToolbarModule } from "@angular/material/toolbar";

import { TranslatePipe } from "#modules/shared/i18n";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbarModule, TranslatePipe],
})
export class FooterComponent {
  private readonly location = inject(Location);

  getYear() {
    return new Date().getFullYear();
  }

  goBack() {
    this.location.back();
  }
}
